import { useQuery } from '@apollo/client/react';
import { useMelwaysInfo } from '@seek/melways-react';

import { gql } from 'src/__generated__';
import { useConfig } from 'src/context/config';

export function useEducationData() {
  const { config } = useConfig();
  const { language } = useMelwaysInfo();

  const { data } = useQuery(QUALIFICATIONS_QUERY, {
    variables: {
      zone: config.ZONE,
      languageCode: language,
    },
  });

  return {
    qualifications: data?.viewer?.qualifications || [],
  };
}

const QUALIFICATIONS_QUERY = gql(`
  query GetQualifications($zone: Zone!, $languageCode: LanguageCodeIso!) {
    viewer {
      ...RefreshedQualifications
    }
  }
`);
